import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_PORTAL_AUTH_REQUEST: '',
  GET_PORTAL_AUTH_SUCCESS: '',
  GET_PORTAL_AUTH_FAILURE: '',

};

types = setStoreTypeValues(types, 'authPortal');

export default types;
